function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  const configuredUrl = getConfig("VITE_BACKEND_URL");
  const hostname = window.location.hostname;

  // The public CRM and its adapter are served by the same VPS/domain. A
  // localhost URL embedded during a local build would otherwise make every
  // visitor call their own computer instead of the server.
  if (hostname !== "localhost" && hostname !== "127.0.0.1") {
    return window.location.origin;
  }

  return configuredUrl || window.location.origin;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
